import { render } from "./LoginRootCaptcha.vue?vue&type=template&id=6864e098"
import script from "./LoginRootCaptcha.vue?vue&type=script&lang=js"
export * from "./LoginRootCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__